import { render, staticRenderFns } from "./FiMoneyInput.vue?vue&type=template&id=117b061e&lang=pug&"
import script from "./FiMoneyInput.vue?vue&type=script&lang=js&"
export * from "./FiMoneyInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports